import { head, range } from 'ramda'
import { parse } from '@datasert/cronjs-parser'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { changeCronValue } from './_helpers/cron'
import { useForm, useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../EditableSentence'
import Text from '../../../../../packages/kiti/components/presentation/Text'

const DAYS = range(1, 32)

const DayOfMonthSentence = () => {
  const form = useForm()
  const { t } = useTranslation('triggers')
  const { handleChange } = useFormState()

  if (form.event !== 'every_month') return false

  const frequency = head(parse(form.frequency || '* * * * *')?.expressions)
  const value = frequency?.day_of_month?.values
  const hasManyDays = value?.length > 1

  const onChangeDays = days => {
    days = days.sort().join(',')
    handleChange('frequency', changeCronValue(frequency, 'dayOfMonth', days))
  }

  return (
    <>
      <Text size="h2">
        {' '}
        no{hasManyDays && 's'} dia{hasManyDays && 's'}{' '}
      </Text>
      <EditableSentence
        field="days"
        label={
          DAYS?.filter(item => value?.includes(item))
            ?.map(day => day)
            .join(', ') || '_____'
        }
        value={value}
        onChange={onChangeDays}
        options={DAYS}
        truncate={15}
        width={12}
        disableCloseOnChange
        disableCloseOnBlur
        multiple
      />
    </>
  )
}

export default DayOfMonthSentence
